import { useQuery } from "@tanstack/react-query";

import { getChallengesForEmployee } from "@/sales-tools/challenges/api/getChallengesForEmployee";
import { useLogger, usePartner } from "@/sdk";

export const useChallenges = () => {
    const logger = useLogger({ module: "useChallenges", supportTeam: "sales" });

    const partner = usePartner();
    const { data, isLoading, isError, isFetching } = useQuery({
        queryKey: [`get-challenge`, partner],
        queryFn: async () => {
            logger.info("Fetching challenges for this participant");
            try {
                const result = await getChallengesForEmployee(logger, partner);
                logger.info({ challengeCount: result?.length ?? 0 }, "Successfully fetched challenges");
                return result;
            } catch (error) {
                logger.warn({ error }, "Failed to fetch challenges");
                throw error;
            }
        },
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: 1,
    });
    return { data, isLoading, isError, isFetching };
};
